if (!customElements.get('cs-header')) {
  customElements.define('cs-header', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.navigation = this.querySelector('.cs-header__navigation');
      this.menuButton = this.querySelector('[data-menu-toggle]');
      this.disclosures = [...this.querySelectorAll('.cs-header__disclosure')];
      this.desktop = window.matchMedia('(min-width: 1024px)');
      this.hoverCloseTimers = new Map();

      this.menuButton.addEventListener('click', () => {
        this.setMobileMenu(this.menuButton.getAttribute('aria-expanded') !== 'true');
      }, options);

      this.disclosures.forEach((details) => {
        details.addEventListener('pointerenter', (event) => {
          if (!this.desktop.matches || event.pointerType !== 'mouse') return;
          this.cancelHoverClose(details);
          this.closeDisclosures(details);
          details.open = true;
        }, options);

        details.addEventListener('pointerleave', (event) => {
          if (!this.desktop.matches || event.pointerType !== 'mouse') return;
          this.cancelHoverClose(details);
          // Allow the pointer to cross the small gap into the dropdown.
          this.hoverCloseTimers.set(details, setTimeout(() => {
            this.hoverCloseTimers.delete(details);
            if (!details.contains(document.activeElement)) details.open = false;
          }, 220));
        }, options);

        details.addEventListener('focusout', (event) => {
          if (this.desktop.matches && event.relatedTarget &&
              !details.contains(event.relatedTarget) && !details.matches(':hover')) {
            this.cancelHoverClose(details);
            details.open = false;
          }
        }, options);

        details.addEventListener('toggle', () => {
          if (details.open) this.closeDisclosures(details);
        }, options);
      });

      this.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape') return;
        const openDisclosure = this.disclosures.find((details) => details.open);
        if (openDisclosure) {
          openDisclosure.open = false;
          openDisclosure.querySelector('summary').focus();
        } else if (!this.desktop.matches && !this.navigation.hidden) {
          this.setMobileMenu(false);
          this.menuButton.focus();
        }
      }, options);

      document.addEventListener('pointerdown', (event) => {
        if (!this.contains(event.target)) {
          this.closeDisclosures();
          if (!this.desktop.matches) this.setMobileMenu(false);
        }
      }, options);

      this.addEventListener('focusout', (event) => {
        if (event.relatedTarget && !this.contains(event.relatedTarget)) {
          this.closeDisclosures();
          if (!this.desktop.matches) this.setMobileMenu(false);
        }
      }, options);

      this.desktop.addEventListener('change', () => this.syncViewport(), options);
      this.syncViewport();
      this.resizeObserver = new ResizeObserver(() => this.updateHeight());
      this.resizeObserver.observe(this);
      this.updateHeight();
    }

    cancelHoverClose(details) {
      clearTimeout(this.hoverCloseTimers.get(details));
      this.hoverCloseTimers.delete(details);
    }

    closeDisclosures(except) {
      this.disclosures.forEach((details) => {
        if (details !== except) {
          this.cancelHoverClose(details);
          details.open = false;
        }
      });
    }

    setMobileMenu(open) {
      this.navigation.hidden = !open;
      this.menuButton.setAttribute('aria-expanded', String(open));
      this.menuButton.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
      this.classList.toggle('is-menu-open', open);
      if (!open) this.closeDisclosures();
    }

    syncViewport() {
      this.setMobileMenu(false);
      this.menuButton.hidden = this.desktop.matches;
      this.navigation.hidden = !this.desktop.matches;
    }

    updateHeight() {
      // Exclude the expanded mobile navigation so its scroll area stays usable.
      const utility = this.querySelector('.cs-header__utility').offsetHeight;
      const main = this.querySelector('.cs-header__main').offsetHeight;
      const nav = this.desktop.matches ? this.navigation.offsetHeight : 0;
      document.documentElement.style.setProperty('--cs-header-height', `${utility + main + nav}px`);
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.resizeObserver?.disconnect();
      this.hoverCloseTimers?.forEach((timer) => clearTimeout(timer));
      document.documentElement.style.removeProperty('--cs-header-height');
    }
  });
}
